module.exports = __webpack_public_path__ + "img/FPC.4d53ddee.jpg";